import React from 'react';
import PropTypes from 'prop-types';

import Grid from '../../../components/Grid';
import Accordion from '../../../components/Accordion';

const Lifts = (props) => {
  let lifts = null;
  if (props.lifts && props.lifts.length > 0) {
    const liftData = props.lifts;
    lifts = liftData.map((lift) => {
      return {
        title: (
          <Grid
            className="title"
            columns={[
              <div key="name" className={`icon lift-type-${lift.class}`}>
                <p>{lift.name}</p>
              </div>,
              <p key="type">{Drupal.t(lift.type)}</p>,
              <div key="status" className="status">
                {lift.info ??
                  (lift.open_today ? (
                    <p>
                      {Drupal.t('Open', {}, { context: 'Opening hours' })}{' '}
                      {lift.open_today}
                    </p>
                  ) : (
                    Drupal.t('Closed')
                  ))}
              </div>,
            ]}
          />
        ),
        content: (
          <Grid
            columns={[
              <div key="open" className="opening-hours">
                <p className="opening-hours-title">
                  {Drupal.t('Opening hours')}
                </p>
                {lift.opening_hours.map((opening, i) => (
                  <p key={i} className="opening-times">
                    {Drupal.t(opening.weekday)} {opening.opens}
                  </p>
                ))}
              </div>,
              <div key="2"></div>,
              <div key="3"></div>,
            ]}
          />
        ),
      };
    });
  }

  return (
    <div className="lifts">
      <h3>
        {props.lifts.length} {Drupal.t('lifts', {}, { context: 'count' })}
      </h3>
      <Grid
        className="heading"
        columns={[
          <strong key="column-1">{Drupal.t('Name')}</strong>,
          <strong key="column-2">{Drupal.t('Lift type')}</strong>,
          <strong key="column-3">{Drupal.t('Opening hours')}</strong>,
        ]}
      />
      <div className="accordion-list">
        {lifts ? (
          lifts.map((lift, i) => (
            <div key={i} className="accordion-list__item">
              <Accordion title={lift.title} content={lift.content} />
            </div>
          ))
        ) : (
          <h3>{Drupal.t('Lifts info not available.')}</h3>
        )}
      </div>
    </div>
  );
};

Lifts.propTypes = {
  lifts: PropTypes.array,
};

export default Lifts;
